//QSL_Staff Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import settings from "../Settings/QSL_Settings"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import store from "../../veux/store"

let Countries, StaffStatus, Clubs
let step1, step2


// QSL Staff Step Schema
const Load_QSL_Staff_Steps = () => {
    return {
        Portal: '2024 QSL Staff',
        MainColor: "#f5924c",
        Logo: require(`../../assets/QSLT.png`),
        Title: `<h2>2024 QSL Staff Registration Form</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: '',
                Schema: {
                    DOB: {
                        type: 'text',
                        ext: 'date',
                        locale: 'en',
                        label: `Date of Birth (${store.getters.getdateFormat})`,
                        outlined: true,
                        dense: true,
                        mask: store.getters.getdateMask,
                        rules: [rules.requiredMsg('Date of Birth is Required'),
                        rules.minAge(`The QSL1 has a minimum age in all divisions that a coach
                                    must turn at least 14 years of age during
                                    the year in which the coach seeks to register.
                                    You are not eligible to register for this current competition year`, '2010-01-01')],
                        class: 'mx-1 px-1',
                        onInput: (ev, portal) => { },
                        OUG: { Contacts: { Field: "date_of_birth" } }
                    },
                    birthCountry: {
                        id: "3394",
                        type: 'select',
                        label: 'Country of Birth?',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Country of Birth is Required')],
                        class: 'mx-1 px-1',
                        items: Countries,
                        OUG: { Contact_Details: { Type: 3394, Action: "Unique" } }
                    },
                    StaffStatus: {
                        id: "3373",
                        type: "select",
                        label: "Staff Status",
                        outlined: true,
                        dense: true,
                        class: 'mx-1 px-1',
                        rules: [rules.requiredMsg('Staff Status is Required')],
                        items: StaffStatus,
                        value: '',
                        OUG: { Contact_Details: { Type: 3373, Action: "Unique" } }
                    },
                    CompSelect: {
                        "type": "select",
                        "label": "Competition Selection",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Competition Selection is Required')],
                        class: 'mx-1 px-1',
                        items: settings.CompType,
                        onInput: async (ev, portal) => {
                            Clubs = await settings.LookupTeams({
                                State_Champs: 3505,
                                Gender: functions.getCompGender(ev.data.CompSelect)
                            })
                            ev.schema.Teams.items = Clubs
                        }
                    },
                    Teams: {
                        type: "select",
                        label: "Which Club are you registering for?",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Club is Required')],
                        class: 'mx-1 px-1',
                        items: Clubs,
                        returnObject: true,
                        itemText: 'Detail',
                        Role: null,
                        Accreditation: null,
                        AccredStart: '',
                        AccredEnd: '',
                        noDataText: 'Please Enter Competition Selection First',
                        AccredTeam: 3505,
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    },
                    Position: {
                        type: "select",
                        label: "Staff Position",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Staff Position is Required')],
                        class: 'mx-1 px-1',
                        items: settings.StaffRoles,
                        value: '',
                        onInput: async (ev, portal) => {
                            let index = settings.StaffRoles.findIndex((ele) => {
                                return (ele == ev.data.Position);
                            })
                            ev.schema.Teams.Role = settings.StaffRoleids[index]
                            ev.schema.Teams.Accreditation = settings.StaffAccredids[index]
                        },
                        OUG: { Contact_Details: { Type: 346, Action: "SingleDesc" } }
                    },
                },
                PreStep: (thisStep, portal) => {
                    let { Model, Schema } = thisStep
                    store.getters.birthCountry ? portal.Model.birthCountry = store.getters.birthCountry : null
                    store.getters.birthCountry ? Schema.birthCountry.value = store.getters.birthCountry : null
                    store.getters.StaffStatus ? portal.Model.StaffStatus = store.getters.StaffStatus : null
                    store.getters.StaffStatus ? Schema.StaffStatus.value = store.getters.StaffStatus : null
                },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Integrity',
                valid: true,
                information: `<div style="padding-bottom: 25px; line-height: 200%">
                                All Staff  must complete the following E-Learning sessions provided by Sport Integrity Australia and BA to complete your registration and compete in QSL1.
                                <br>
                                1. Basketball Australia Integrity - Gambling and Match-Fixing Course
                                <br>
                                2. Level 1 Anti-Doping Course (or prior ASADA Anti-Doping Level 1)
                                <br>
                                3. Annual Update 2024
                                <br>
                                All these courses can be found via the following link. <a href="https://elearning.sportintegrity.gov.au" target = "_blank" > Visit Sport Integrity Site</a >
                                <br>
                                There is now a BA requirement to complete the following course and upload your certificate
                                <br>
                                <a href="https://membership.mygameday.app/regoform.cgi?formID=97715&programID=62892" target="_blank">BA Integrity - Gambling and Match-Fixing Course</a>
                                <br>
                                If you have already done the course please use the link below to retrieve your certificate:
                                <br>
                                <a href="https://basketballaustralia.etrainu.com/training/index.cfm?event=page.login" target="_blank">Retrieve BA Gambling and Match-Fixing Certifcate</a>
                                <br>
                                    Once complete, staff must upload their Elearning Certificate, showing all completed course badges.
                                </div>`,
                Model: {},
                Schema: {
                    MatchFixing: {
                        type: 'file',
                        label: 'BA Integrity Certificate',
                        multiple: false,
                        outlined: true,
                        hidden: store.getters.integrity,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Introduction to Match-Fixing",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">Basketball Australia Gambling and Match Fixing Course Certificate – (Please upload a screenshot of your Certificate <a href="https://admin.ownurgoal.net.au/_lib/file/doc/GamblingMatchFixingExample.jpg" target="blank">Click Here for Example</a>)</p>`
                    },
                    haveMatchFixing: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: !store.getters.integrity,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We already have a copy of your BA Integrity Gambling & Match Fixing Certificate</H4>`
                    },
                    AnnualUpdate2024: {
                        type: 'file',
                        label: 'Annual Update 2024',
                        multiple: false,
                        outlined: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [rules.requiredMsg('Annual Update 2024 Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "Annual Update 2024 Certificate",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">SIA Anti-Doping Fundamentals badges – (Please upload a screenshot of your SIA Badges page <a href="https://admin.ownurgoal.net.au/_lib/file/doc/SIAExample.jpg" target="blank">Click Here for Example</a>, which must show the SIA Anti-Doping Fundamentals badge, AS WELL AS the SIA 2024 annual update badge)</p>`
                    },
                    BAIntegrity: {
                        type: 'checkbox',
                        label: `Please check this box if you agree to abide by Basketball Australia's National Integrity Framework`,
                        color: "primary",
                        value: "Agree to BA National Integrity Framework",
                        rules: [rules.requiredMsg('Confirmation of acceptance of BA Integrity Framework is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Integrity Requirements</h3>`,
                        Endslot: `<h4 class="slot">
                                        I agree to abide with the BA National Integrity Framework, BA may share personal information relating to Participants with Betting Operators, law enforcement agencies, government agencies or other sporting organisations to prevent and investigate match-fixing incidents.
                                        <br>
                                            <a href="https://australia.basketball/integrity/" target="_blank">Click here to review National Integrity Framework</a>
                                    </h4>`,
                        OUG: { Answer: true }
                    },
                },
                PreStep: (thisStep, portal) => {
                    let { Schema } = thisStep
                    Schema.MatchFixing.hidden = store.getters.integrity
                    Schema.MatchFixing.rules = (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required')]
                    Schema.haveMatchFixing.hidden = !store.getters.integrity
                },
            },
            //Step 5
            {
                stepno: 5,
                title: 'Confirmation',
                valid: true,
                information: ``,
                Model: {},
                Schema: {
                    Participate: {
                        addText: "",
                        type: 'checkbox',
                        label: `I have read and agree to the terms and conditions of participation 
                                        in QSL1 as laid out in QSL1 Rules.`,
                        color: "primary",
                        value: "Agree to all Terms and Conditions for QSL1",
                        rules: [rules.requiredMsg('Confirmation of acceptance of Terms and Conditions for QSL1 is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Endslot: `<a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/55e04730-5930-4e15-8145-04e01ef5f6de.pdf" target="blank">
                                        QSL1 Rules</a>`,
                        OUG: { Answer: true }
                    },
                    cocConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the Basketball Queensland Code of Conduct`,
                        color: "primary",
                        value: "Confirm I will adhere to BQ Code of Conduct",
                        rules: [rules.requiredMsg('Confirmation of Code of Conduct is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Endslot: `<a href="https://assets-global.website-files.com/645c37312e4131ceca6d3887/6461903dbf7e8d2d4187eea8_BQ-Codes-of-Behaviour.pdf" target="blank">
                                        Basketball Queensland Code of Conduct</a>`,
                        OUG: { Answer: true }
                    },
                    foreignPlayer: {
                        type: 'checkbox',
                        label: `I agree that if I do not currently have Australian Citizenship, I will gain Basketball Australia approval each competition year so I am eligible to coach in any QSL1 match.`,
                        color: "primary",
                        value: "I Confirm I meet Foreign Coach Conditions",
                        rules: [rules.requiredMsg('Confirmation of Foreign Coach Requirement is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Foreign Coach Requirements</h3>`,
                        Endslot: `<a href="https://www.australia.basketball/get-involved/pathways/immigration" target="blank">
                            Basketball Australia Immigration Policy (non current Australian Citizens)</a>`,
                        OUG: { Answer: true }
                    },
                    baIntegrityConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I agree to abide by Basketball Australia's National Integrity Framework`,
                        color: "primary",
                        value: "Agree to BA National Integrity Framework",
                        rules: [rules.requiredMsg('Confirmation of BA Integrity Requirements is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Endslot: `<a href="https://australia.basketball/integrity/" target="blank">
                                        Basketball Australia National Integrity Framework</a>`,
                        OUG: { Answer: true }
                    },
                    useImages: {
                        addText: "",
                        type: 'checkbox',
                        label: `I acknowledge that BQ, QSL and my Club may use images, video, or similar of me for the promotion of the League and the Club.`,
                        color: "primary",
                        value: "Acknowledge use of my Images and Video",
                        rules: [rules.requiredMsg('Use of Images confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        OUG: { Answer: true }
                    },
                    Concussion: {
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the Basketball Queensland Concussion Protocols`,
                        color: "primary",
                        value: "I Confirm I will adhere to BQ Concussion Protocols",
                        rules: [rules.requiredMsg('Confirmation of BQ Concussion Protocols is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Concussion Requirements</h3>`,
                        Endslot: `<a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/BA-Concussion-Guidelines-Harcourt-FINAL.pdf" target="blank">
                                            Basketball Queensland Concussion Protocols</a>`,
                        OUG: { Answer: true }
                    },
                    attendTribunal: {
                        addText: "",
                        type: 'checkbox',
                        label: 'I undertake to attend meetings of the Basketball Queensland Tribunal whenever required to do so and consent to the subsequent reporting of the proceedings of such meetings and hearings.',
                        color: "primary",
                        value: "Agree to attend Tribunal or other meetings",
                        rules: [rules.requiredMsg('Agreement to Attend is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        OUG: { Answer: true }
                    },
                    infoAccurate: {
                        addText: "",
                        type: 'checkbox',
                        label: 'I confirm that I have provided infomation honestly and that it is both true and accurate.',
                        color: "primary",
                        value: "Confirm information all honest and correct",
                        rules: [rules.requiredMsg('Accurate Information confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        OUG: { Answer: true }
                    },
                },
            },
            // Step 6
            {
                stepno: 6,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 QSL1 season.<br></br>
                            Please note this submitted registration is <b>PENDING APPROVAL</b> from the 
                            league and you and your Association Delegate will receive an email notification 
                            once your registration has been reviewed and approved by the league.<br></br>
                            If your registration has not been approved the league will contact your 
                            Association Delegate to inform them of any further requirements to meet 
                            league eligibility approval for the season.<br></br>

                            <b>Please note that if your registration has been submitted during the 
                            season after 4pm on the Friday prior to a weekends round your 
                            registration will NOT be reviewed and/or approved until the following 
                            round as you have missed that weekends round deadline to submit your 
                            registration.</b>
                            <hr><br></br>`,
                Model: {},
                Schema: {}
            }
        ]
    }
}

export default {

    LoadSchema: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        Countries = await functions.GetCountries();
        StaffStatus = await functions.GetCodeBy({ Type: "NBL1 Playing Status" });
        return Load_QSL_Staff_Steps()
    },

}